theme.cookies = (function(){
  const get = ( name ) => {
    // https://stackoverflow.com/a/25490531
    return document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
  };

  const set = (name, value, days) => {
    const d = new Date();
    d.setTime(d.getTime() + (days*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  }

  return {
    get,
    set
  }
})();